(function () {
    'use strict';

    run.admin.parts.rackootImport = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const import_rackoot_wrapper = document.getElementById('rackoots_items__import');
        if (import_rackoot_wrapper == null) {
            return;
        }

        const import_rackoot_button = import_rackoot_wrapper.querySelector('button');
        const rackoot_data = document.getElementById('rackoot_data');
        import_rackoot_button.addEventListener('click', async function(e) {
            const rackoot_name = rackoot_data.dataset.name;
            const rackoot_uuid = rackoot_data.dataset.uuid;
            const rackoot_public_token = rackoot_data.dataset.publicToken;
            Swal.fire({
                title: translations.rackoots.import.messages.title,
                html: `
                    <p>`+translations.rackoots.import.messages.body1.replace('{rackoot_name}', rackoot_name)+`</p>
                    <p class="small">`+translations.rackoots.import.messages.body2+`</p>
                    <p class="small">`+translations.rackoots.import.messages.body3+`</p>
                `,
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                focusCancel: true,
                cancelButtonText: translations.rackoots.import.messages.buttonCancel,
                confirmButtonText: translations.rackoots.import.messages.buttonImport,
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-lg btn-light',
                    confirmButton: 'btn btn-lg btn-primary ms-4'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            }).then((result) => {
                if (result.value) {
                    var data = new FormData();
                    data.append('csrf_name', csrf_name);
                    data.append('csrf_value', csrf_value);
                    data.append('uuid', rackoot_uuid);
                    data.append('public_token', rackoot_public_token);
                    
                    axios.post(GlobalRoutes.rackoots.import, data)
                    .then(function (response) {
                        window.location = response.data.data.url;
                    })
                    .catch(function (error) {
                        new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                    });    
                }
            });
        });
    }
})();
